import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch } from "react-redux";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import { viewUnitList } from "../../Redux/Actions/unitsActions";
import {
  editAmenities,
} from "../../Redux/Actions/amenitiesActions";
import AddImage from "../../Global Functions/addImage";
import TextInput from "../../Global Functions/textInput";
import TwoButtons from "../../Global Functions/buttons";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Edit } from "../../Global Icons/Edit.svg";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const EditAmenities = () => {
  const { id } = useParams();

  const [amenityData, setAmenityData] = useState({
    id: id,
    name: "",
    position: Math.floor(Math.random() * 1000) + 1,
    category: "",
    unit: "",
    amenities_for: "",
    image: "",
  });

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    const payloadData = {
      page: 1,
      limit: 1000,
    };
    dispatch(viewCategoryList(payloadData));
    dispatch(viewUnitList(payloadData));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    const imageUrl = await AddImage(file);
    if (imageUrl) {
      setAmenityData((prevData) => ({ ...prevData, image: imageUrl }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      let filteredData = { ...amenityData };
      Object.keys(filteredData).forEach((key) => {
        if (filteredData[key] === "" || filteredData[key] === null) {
          delete filteredData[key];
        }
      });

      const response = await dispatch(editAmenities(filteredData));

      if (response.statusCode === 200) {
        navigate("/amenities");
      }
      setAmenityData({
        name: "",
        position: Math.floor(Math.random() * 1000) + 1,
        category: "",
        unit: "",
        amenities_for: "",
        image: "",
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <MainLayout>
      <div className="padding-20 bg-white border-24 grid-span-5" style={{ width: "100%" }}>
        <form onSubmit={handleSubmit}>
          <div className="flex-container align-center gap-10">
            <Edit></Edit>
            <h1>Edit Amenity</h1>
          </div>
          <div className="flex-container flex-justify-between gap-10"></div>

          <div className="flex-container gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label="Enter Title"
                value={amenityData.name}
                onChange={(event) =>
                  setAmenityData({ ...amenityData, name: event.target.value })
                }
                name="name"
                type="text"
                placeholder="Enter Title"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Add Icon</span>
              <input
                id="image"
                style={{ display: "none" }}
                type="file"
                name="image"
                onChange={(event) => {
                  handleFileChange(event);
                }}
              />
              <label for="image" className="label-class-image">
                Click to Upload Icon
              </label>
              <ImageShowerModalGlobal
                file={amenityData.image}
                keyField="image"
                setState={setAmenityData}
                state={amenityData}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <TwoButtons
            buttonHead1="Cancel"
            buttonHead2="Save"
            onClick2={handleSubmit}
            noUrl={true}
            LinkURL="/amenities"
          ></TwoButtons>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditAmenities;
